import { useGoogleAnalytics } from '@michelin/central-provider/dist/hooks/useGoogleAnalytics';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

let lastSentLocation: string | null = null;
let lastSentTitle: string | null = null;

export default function GoogleAnalyticsPageViews(): null {
  const location = useLocation();
  const googleAnalytics = useGoogleAnalytics();
  const googleAnalyticsRef = useRef(googleAnalytics);
  const isInitialized = googleAnalytics?.isInitialized;

  googleAnalyticsRef.current = googleAnalytics;

  useEffect(() => {
    if (!isInitialized) return;

    const currentLocation = `${location.pathname}${location.search}${location.hash}`;
    if (currentLocation === lastSentLocation) return;

    const sendPageView = () => {
      if (currentLocation === lastSentLocation) return;

      googleAnalyticsRef.current?.pageview(currentLocation, undefined, document.title);
      lastSentLocation = currentLocation;
      lastSentTitle = document.title;
    };

    const titleObserver = new MutationObserver(sendPageView);
    titleObserver.observe(document.head, { childList: true, subtree: true, characterData: true });

    // The title may be set before the observer is registered.
    requestAnimationFrame(() => {
      if (lastSentLocation === null || document.title !== lastSentTitle) sendPageView();
    });

    return () => titleObserver.disconnect();
  }, [location.pathname, location.search, location.hash, isInitialized]);

  return null;
}